import React, { useEffect } from "react";
import { useQuery } from "@apollo/client/react";
import {
  GetPrintableCombineAtomic_patient as Patient,
  GetPrintableCombineAtomicVariables,
  GetPrintableCombineAtomic,
} from "./types/GetPrintableCombineAtomic";
import getPrintableCombineAtomic from "./GetPrintableCombineAtomicQuery";
import { useParams, useLocation } from "react-router";
import get from "lodash/get";
import queryString from "query-string";
import PrintableCombineAtomic from "./PrintableCombineAtomic";
import { auditLogHelper } from "../../utils/mutationHelper";

type PathParams = {
  patientId: string;
  allPatients: string;
};

const getReportIds = (search: any): number[] | null =>
  search.ids
    ? search.ids.split(",").map((item: string) => {
        return parseInt(item, 10);
      })
    : null;

const getDownloadMode = (search: any): number => (search.downloadMode ? Number(search.downloadMode) : 0);

const getLabNoDigitOnly = (search: any): string => (search.labnoDigitOnly ? search.labnoDigitOnly : "0");

const queryVariables = (
  labnoDigitOnly: string,
  params: PathParams,
  reportIds: number[],
): GetPrintableCombineAtomicVariables => ({
  patientId: parseInt(params.patientId, 10),
  labnoDigitOnly: labnoDigitOnly,
  ids: reportIds,
});

const hasValidData = (data: GetPrintableCombineAtomic | undefined) => data && data.combineAtomic;

const PrintableCombineAtomicPage: React.FC<any> = () => {
  const params: PathParams = useParams() as PathParams;
  const location = useLocation();
  const reportIds = getReportIds(queryString.parse(location.search));
  const downloadMode = getDownloadMode(queryString.parse(location.search));
  const labnoDigitOnly = getLabNoDigitOnly(queryString.parse(location.search));

  const { data, loading } = useQuery<GetPrintableCombineAtomic>(getPrintableCombineAtomic, {
    variables: queryVariables(labnoDigitOnly, params, reportIds || []),
  });

  const value = JSON.stringify({
    reportIds: reportIds,
    useragent: navigator.userAgent,
  });
  const action = "PRINT_COMPRESSED";

  useEffect(() => {
    if (!loading && data) {
      const input: any = {
        audit: {
          value,
          action,
        }
      };
  
      auditLogHelper(input);
    }
  }, [data, loading, value]);

  if (loading || !hasValidData(data)) return null;

  const patient: Patient = get(data, "patient") || ({} as Patient);

  const atomics = data && data.combineAtomic ? data.combineAtomic : [];

  return (
    <PrintableCombineAtomic
      atomics={atomics}
      patient={patient}
      downloadMode={downloadMode}
      isMultiPatientReport={false}
    />
  );
};

export default PrintableCombineAtomicPage;
